export const maskitoMasks = {
  phone: {
    placeholder: '999-999-9999',
    mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  },
  postalCode: {
    placeholder: 'X0X 0X0',
    mask: [/[A-Za-z]/, /\d/, /[A-Za-z]/, ' ', /\d/, /[A-Za-z]/, /\d/]
  },
  zipCode: {
    placeholder: '99999 or 99999-9999',
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  },
  creditCard: {
    placeholder: '9999-9999-9999-9999',
    mask: [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ]
  },
  creditCardAmex: {
    placeholder: '9999-999999-99999',
    mask: [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ]
  },
  creditCardExpiryDate: {
    placeholder: 'MM/YY',
    mask: [/\d/, /\d/, '/', /\d/, /\d/]
  }
};
